import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import { Layout, Metadata, Image, Content, PreviewContent } from '../components';
import { vr } from '../utils';
import FacebookIcon from '../img/facebook.inline.svg';

export const NewsPostTemplate = ({ content, title, featuredImage, isPreviewMode, date }) => {

  const PageContent = isPreviewMode ? PreviewContent : Content;

  let url = typeof window !== 'undefined' ? window.location.href : '';

  useEffect(() => {
    url = typeof window !== 'undefined' ? window.location.href : '';
  }, []);

  return (
    <>

      <Jumbotron data-overlay="half">
        <Image
          src={featuredImage}
          alt={title}
          applyCloudinary
          breakpoints={[
            { width: 300 },
            { width: 400 },
            { width: 500 },
            { width: 600 },
            { width: 768 },
            { width: 940 },
            { width: 1024 },
            { width: 1200 },
            { width: 1400 },
            { width: 1800 },
          ]}
          sizes="100vw"
          style={{ height: 'inherit' }}
        />
      </Jumbotron>

      <div className="container page-content">
        <article>
          <h1>{title}</h1>
          <small>{date}</small>
          <PageContent>{content}</PageContent>
          { (!isPreviewMode && url !== '') && (
            <SocialLink href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}>
              <FacebookIcon />
              Del på Facebook
            </SocialLink>
          )}
        </article>
      </div>

    </>
  );
};

NewsPostTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  featuredImage: PropTypes.oneOfType([ PropTypes.object, PropTypes.string ]).isRequired,
  date: PropTypes.string.isRequired,
};

NewsPostTemplate.defaultProps = {

};

const Jumbotron = styled.div`
  height: calc(100vh - 200px);
  overflow: hidden;

  .gatsby-image-wrapper {
    height: inherit;
  }

  span {
    display: none;
  }

  img {
    width: 100%;
  }
`;

const NewsPost = ({ data }) => {
  const { mdx: post } = data;

  const hasImage = post?.frontmatter?.featuredImage;

  return (
    <Layout>
      <Metadata
        title={post.frontmatter.title}
        image={hasImage ? post.frontmatter.featuredImage : null}
        description={post.excerpt}
      />
      <NewsPostTemplate
        title={post.frontmatter.title}
        content={post.body}
        featuredImage={post.frontmatter.featuredImage}
        date={post.frontmatter.date}
      />
    </Layout>
  );
};

const SocialLink = styled.a`
  line-height: 32px;
  display: inline-block;
  margin-top: ${vr(1)};

  svg, img {
    height: 32px;
    width: 32px;
    margin: 0 10px 0 0;
    float: left;
  }
`;

NewsPost.propTypes = {
  data: PropTypes.shape({
    mdx: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }).isRequired,
};

export default NewsPost;

export const newsQuery = graphql`
  query NewsPostByID($id: String!) {
    mdx(id: { eq: $id }) {
      id
      body
      excerpt(pruneLength: 160)
      frontmatter {
        date(formatString: "D. MMMM YYYY", locale: "DA")
        title
        featuredImage
      }
    }
  }
`;
